import React from 'react'
import CounsellorsSidebar from './CounsellorsSidebar'

const PreviousSessions = () => {
    return (
        <div>
            <div className="counsNav">
                <CounsellorsSidebar/>
            </div> 
        </div>
    )
}

export default PreviousSessions
